import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
//prime React
import { Button } from "primereact/button";
import { getNewSessionWAPP } from "../../../../services/Enterprise/WhatsppConfig/getNewSessionWAPP";
import ConnectedGif from "../../../../assets/whatsapp/gif_checked.gif";
import ConnectedEstatic from "../../../../assets/whatsapp/gif_checked_estatic.gif";

import { Skeleton } from "primereact/skeleton";
import { getStatusConnectionWAPP } from "../../../../services/Enterprise/WhatsppConfig/getStatusConnectionWAPP";

export default function WhatsappConnect({ id, enterpriseName, setIsDisable }) {
  // eslint-disable-next-line no-unused-vars
  const [defaultValues, setDefaultValues] = useState({});
  const [showStaticImage, setShowStaticImage] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [statusConnection, setStatusConnection] = useState(undefined);
  const [connected, setConnected] = useState(false);
  const [qrCode, setQrCode] = useState(undefined);
  const [infoClient, setInfoClient] = useState(undefined);
  const [infoClientLoaded, setInfoClientLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [contador, setContador] = useState(1);

  const form = useForm({ defaultValues });

  useEffect(() => {
    getStatusConnectionWAPP(id).then((result) => {
      if (result.state !== "CONNECTED" && contador === 1) {
        let objData = {
          enterprise_id: id,
        };
        // Se o status não for CONNECTED, chame a função para obter um novo código QR
        getNewSessionWAPP(objData)
          .then((resultSession) => {
            setQrCode(resultSession);
          })
          .catch((error) => {
            console.error("Error fetching new session:", error);
          });
      } else {
        setConnected(true);
        setInfoClientLoaded(true);
        setInfoClient(result.data);
        setIsDisable(false);
      }
      setContador(contador + 1);
      setStatusConnection(result);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = async (data) => {
    setIsLoading(true);
    const resultConnection = await getStatusConnectionWAPP(id);
    if (resultConnection.state === "CONNECTED") {
      setConnected(true);
      setInfoClientLoaded(true);
      setInfoClient(resultConnection.data);
      setIsDisable(false);
    }
    setIsLoading(false);
  };

  // const getFormErrorMessage = (name) => {
  //   return errors[name] ? (
  //     <small className="p-error">{errors[name].message}</small>
  //   ) : (
  //     <small className="p-error">&nbsp;</small>
  //   );
  // };
  function formatPhoneNumber(phoneNumber) {
    // Remove caracteres não numéricos do número de telefone
    phoneNumber = phoneNumber.replace(/\D/g, "");

    // Verifica o tamanho do número para determinar o formato
    var length = phoneNumber.length;

    if (length >= 11 && phoneNumber.substring(0, 2) === "55") {
      // Formato para números brasileiros que começam com "55": +55 (XX) 9XXXX-XXXX
      var formattedNumber =
        "+55 (" +
        phoneNumber.substring(2, 4) +
        ") " +
        phoneNumber.substring(4, 9) +
        "-" +
        phoneNumber.substring(9);
    } else {
      // Tamanho de número inválido
      var formattedNumber = "Número de telefone inválido";
    }

    return formattedNumber;
  }
  useEffect(() => {
    if (infoClientLoaded) {
      const timer = setTimeout(() => {
        setShowStaticImage(true);
      }, 1800);

      // Limpa o timer ao desmontar o componente
      return () => clearTimeout(timer);
    }
  }, [infoClientLoaded]);

  useEffect(() => {
    if (qrCode) {
      const interval = setInterval(() => {
        onSubmit();
      }, 7000); // 5000 milissegundos = 5 segundos

      return () => clearInterval(interval);
    }
  }, [qrCode]);

  return (
    <>
      {connected === false && contador > 1 ? (
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-md-8">
              <h1 style={{ marginBottom: "15px" }}>Conectar ao WhatsApp</h1>
              <ol>
                <li style={{ marginBottom: "15px" }}>
                  Abra o WhatsApp<strong> </strong> no seu celular.
                </li>
                <li style={{ marginBottom: "15px" }}>
                  Toque em <strong>Mais opções </strong>{" "}
                  <i className="fa-solid fa-ellipsis-vertical"></i> no Android
                  ou em <strong>Configurações</strong>{" "}
                  <i className="fa-solid fa-gear"></i> no iPhone.
                </li>
                <li style={{ marginBottom: "15px" }}>
                  Toque em <strong>Dispositivos conectados</strong> e, em
                  seguida, em <strong>Conectar dispositivo</strong>.
                </li>
                <li style={{ marginBottom: "15px" }}>
                  Aponte seu celular para esta tela para escanear o QR code.
                </li>
              </ol>
            </div>
            <div className="row col-md-4 my-auto text-end">
              {/* Renderize o QR code somente se estiver disponível */}
              {qrCode && qrCode.success.qrCode && (
                <img
                  style={{ width: "80%", height: "auto" }}
                  alt="QR Code WhatsApp"
                  src={qrCode.success.qrCode}
                />
              )}
              {(!qrCode || !qrCode.success.qrCode) && (
                <>
                  {/* Substitua a imagem do QR Code pelo Skeleton Loader */}
                  <Skeleton variant="rect" width={300} height={300} />
                </>
              )}
            </div>
          </div>

          <hr className="my-4" />
          <div className="col-md-12 text-end">
            {/* <Button
              rounded
              type="submit"
              loading={isLoading}
              iconPos="right"
              label="Testar Conexão"
              icon="fa-solid fa-circle-chevron-right"
              className="p-inputtext-sm m-auto"
            /> */}
          </div>
        </form>
      ) : (
        <div className="row">
          {!infoClient && !qrCode && (
            <>
              {/* Substitua a imagem do QR Code pelo Skeleton Loader */}
              <Skeleton variant="rect" width="100%" height={300} />
            </>
          )}
          <div className="col-md-8">
            {infoClient && (
              <>
                <h1 style={{ marginBottom: "50px" }}>
                  Sessão - {enterpriseName}
                </h1>
                <h2 style={{ marginBottom: "15px" }}>
                  {infoClient && infoClient.number.pushname && (
                    <p>
                      {infoClient.number.pushname || ""}{" "}
                      {formatPhoneNumber(infoClient.number.wid.user || "")}
                    </p>
                  )}
                </h2>
              </>
            )}
          </div>
          {infoClient && (
            <>
              <div className="row col-md-4 my-auto text-center">
                {/* Renderize o gif somente se estiver conectado */}
                {showStaticImage ? (
                  <img src={ConnectedEstatic} alt="Conectado" />
                ) : (
                  <img src={ConnectedGif} alt="Conectado" />
                )}
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
